import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub } from "react-icons/ai";
import { FaYoutube, FaSteam } from "react-icons/fa";
import { BsTelegram } from "react-icons/bs";
import { Link } from "react-router-dom";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} ImMaster__</h3>
        </Col>
   
        {/* Link alla Privacy Policy */}
        <Col md="4" className="footer-copywright">
          <h3>
            <Link 
              to="/privacy" 
              style={{ color: "white", textDecoration: "none" }}
            >
              Privacy Policy
            </Link>
          </h3>
        </Col>
        {/* Icone social network */}
        <Col md={{ span: 4 }} className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/ImMaster26"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://t.me/PlayerMasters"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <BsTelegram />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.youtube.com/@immaster__4812"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://steamcommunity.com/id/ImMaster__/"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaSteam />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
